import { useForm, DefaultValues } from 'react-hook-form';
import type { TenantUpdate } from '../types/tenant.types';
import { useCallback } from 'react';

export interface UseTenantFormProps {
  defaultValues?: DefaultValues<TenantUpdate>;
  onSubmit: (data: TenantUpdate) => void;
}

export const useTenantForm = ({ defaultValues, onSubmit }: UseTenantFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm<TenantUpdate>({
    defaultValues: defaultValues || {
      name: undefined,
      addressLine1: undefined,
      addressLine2: undefined,
      city: undefined,
      state: undefined,
      zipCode: undefined,
      primaryEmail: undefined,
      secondaryEmail: undefined,
      primaryPhone: undefined,
      secondaryPhone: undefined,
      defaultLanguage: undefined,
      defaultCurrency: undefined,
      brandingColors: undefined,
    },
  });

  const resetForm = useCallback(() => {
    reset();
  }, [reset]);

  const submitHandler = useCallback(
    (data: TenantUpdate) => {
      // Transform logo array to single string if it exists
      const transformedData = {
        ...data,
        logo: Array.isArray(data.logo) && data.logo.length > 0 ? data.logo[0] : undefined,
      };
      onSubmit(transformedData);
    },
    [onSubmit]
  );

  const formSubmitHandler = useCallback(() => {
    return handleSubmit(submitHandler);
  }, [handleSubmit, submitHandler]);

  return {
    control,
    errors,
    resetForm,
    formSubmitHandler,
    reset,
    setError,
    setValue,
  };
};
